import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <h2>Elec 311 Virtual ClassRoom</h2>
      <p>Share your Answers </p>
    </div>
  )
}

export default Title;